module.exports = __webpack_public_path__ + "img/icon_webpage_outlined_w.00e9cbef.svg";